


































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {IpStatus} from '@/model/network/connection/IpStatus';
import {IpMode} from '@/model/network/IpMode';
import {IpRoute} from '@/model/network/IpRoute';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class NetworkIpStatusDisplay extends Mixins<BaseComponent>(BaseComponent) {
  private IpMode = IpMode;

  @Prop(Object)
  private ipStatus!: IpStatus;

  @Prop(String)
  private mode!: IpMode;

  @Prop({default: true})
  private showRoutes!: boolean;

}
